export const ar = {
  // Navigation
  nav: {
    home: "الرئيسية",
    aboutUs: "من نحن",
    ourServices: "خدماتنا",
    specialOffers: "العروض الخاصة",
    contactUs: "اتصل بنا",
    search: "بحث",
    searchPlaceholder: "ابحث في الخدمات...",
    searchLoading: "جاري البحث...",
    noResults: "لم يتم العثور على خدمات",
    searchResults: "نتائج البحث",
    searchHint: "أدخل 3 أحرف على الأقل للبحث عن الخدمات",
  },

  // Header
  header: {
    followSocialMedia: "تابع وسائل التواصل الاجتماعي",
  },

  // Hero Section
  hero: {
    title: "نقود مستقبل حلول الأعمال",
    subtitle: "حلول تكنولوجية مبتكرة للمؤسسات الحديثة",
    getStarted: "ابدأ الآن",
    learnMore: "اعرف المزيد",
  },

  // Intro Section
  intro: {
    title: "من نحن",
    description:
      "نحن شركة رائدة ملتزمة بتقديم حلول مبتكرة وخدمة استثنائية لعملائنا في جميع أنحاء العالم.",
  },

  // Special Offers
  offers: {
    title: "العروض الخاصة",
    description: "صفقات حصرية وعروض ترويجية لعملائنا الكرام",
    viewAll: "عرض جميع العروض",
    readMore: "اقرأ المزيد",
    noOffers: "لا توجد عروض خاصة متاحة في الوقت الحالي.",
    interestedInOffer: "مهتم بهذا العرض؟",
    offerDescription:
      "تواصل معنا اليوم لمعرفة المزيد عن هذا العرض الخاص وكيف يمكن أن يفيد عملك.",
    loadingOffers: "جاري تحميل العروض...",
    noOffersFound: "لم يتم العثور على عروض",
    offerPic: "صورة العرض",
    companyLogo: "شعار الشركة",
  },

  // Services
  services: {
    title: "خدماتنا",
    description: "حلول مهنية لجميع احتياجاتك",
    viewAll: "عرض جميع الخدمات",
    readMore: "اقرأ المزيد",
    noServices: "لا توجد خدمات متاحة في الوقت الحالي.",
    categories: "الفئات",
    allCategories: "جميع الفئات",
    needThisService: "تحتاج هذه الخدمة؟",
    serviceDescription:
      "تواصل معنا اليوم لمعرفة المزيد عن هذه الخدمة وكيف يمكن أن تفيد عملك.",
    loadingServices: "جاري تحميل الخدمات...",
    noServicesFound: "لم يتم العثور على خدمات",
    noServicesInCategory: "لا توجد خدمات متاحة في هذه الفئة.",
    servicePic: "صورة الخدمة",
    companyLogo: "شعار الشركة",
  },

  // Testimonials
  testimonials: {
    title: "ماذا يقول عملاؤنا",
    noTestimonials: "لا توجد شهادات متاحة في الوقت الحالي.",
  },

  // Contact
  contact: {
    title: "اتصل بنا",
    subtitle: "تواصل معنا",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    subject: "الموضوع",
    message: "الرسالة",
    send: "إرسال الرسالة",
    address: "العنوان",
    getInTouch: "تواصل معنا",
    followUs: "تابعنا",
    contactInfo: "معلومات الاتصال",
    contactUsNow: "اتصل بنا الآن",
    placeholders: {
      name: "أدخل اسمك الكامل",
      email: "أدخل بريدك الإلكتروني",
      phone: "أدخل رقم هاتفك",
      subject: "أدخل الموضوع",
      message: "أدخل رسالتك",
    },
  },

  // Footer
  footer: {
    allRightsReserved: "جميع الحقوق محفوظة.",
    quickLinks: "روابط سريعة",
    services: "الخدمات",
    company: "الشركة",
    support: "الدعم",
  },

  // Common
  common: {
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجح",
    cancel: "إلغاء",
    save: "حفظ",
    edit: "تعديل",
    delete: "حذف",
    add: "إضافة",
    addNew: "إضافة جديد",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    close: "إغلاق",
    submit: "إرسال",
    reset: "إعادة تعيين",
    view: "عرض",
    readMore: "اقرأ المزيد",
    learnMore: "اعرف المزيد",
    getStarted: "ابدأ الآن",
    contactUs: "اتصل بنا",
    aboutUs: "من نحن",
    home: "الرئيسية",
    services: "الخدمات",
    offers: "العروض",
    testimonials: "الشهادات",
    search: "بحث",
    noImageAvailable: "لا توجد صورة متاحة",
    updating: "جاري التحديث...",
  },

  // Language Switcher
  language: {
    english: "English",
    arabic: "العربية",
    switchLanguage: "تغيير اللغة",
  },

  // Dashboard
  dashboard: {
    dashboard: "لوحة التحكم",
    homepageSettings: "إعدادات الصفحة الرئيسية",
    specialOffers: "العروض الخاصة",
    servicesCategories: "فئات الخدمات",
    services: "الخدمات",
    testimonials: "الشهادات",
    linkManagement: "إدارة الروابط",
    analytics: "التحليلات",
    backToTestimonials: "العودة إلى الشهادات",
    editTestimonial: "تعديل الشهادة",
    logout: "تسجيل الخروج",
    logoutConfirm: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
    adminUser: "مستخدم الإدارة",
    administrator: "المدير",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    add: "إضافة",
    back: "رجوع",
    nameEnglish: "الاسم (بالإنجليزية)",
    nameArabic: "الاسم (بالعربية)",
    contentEnglish: "المحتوى (بالإنجليزية)",
    contentArabic: "المحتوى (بالعربية)",
    rating: "التقييم",
    image: "الصورة",
    enterCustomerName: "أدخل اسم العميل",
    enterCustomerNameArabic: "أدخل اسم العميل بالعربية",
    enterTestimonialContent: "أدخل محتوى الشهادة",
    enterTestimonialContentArabic: "أدخل محتوى الشهادة بالعربية",
    loadingTestimonial: "جاري تحميل الشهادة...",
    testimonialUpdatedSuccess: "تم تحديث الشهادة بنجاح!",
    errorUpdatingTestimonial: "خطأ في تحديث الشهادة",
    welcomeBack: "أهلاً وسهلاً",
    viewHomepage: "عرض الصفحة الرئيسية",
    todaysVisitors: "زوار اليوم",
    totalVisitors: "إجمالي الزوار",
    mostVisitedService: "الخدمة الأكثر زيارة",
    mostVisitedOffer: "العرض الأكثر زيارة",
    uniqueVisitors: "زوار فريدون",
    visits: "زيارات",
    period: "الفترة",
    today: "اليوم",
    thisWeek: "هذا الأسبوع",
    thisMonth: "هذا الشهر",
    thisYear: "هذا العام",
    week: "هذا الأسبوع",
    month: "هذا الشهر",
    year: "هذا العام",
    addService: "إضافة خدمة",
    createNewService: "إنشاء خدمة جديدة",
    viewDetailedAnalytics: "عرض التحليلات المفصلة",
    addSpecialOffer: "إضافة عرض خاص",
    createNewOffer: "إنشاء عرض جديد",
    manageTestimonials: "إدارة الشهادات",
    viewAllTestimonials: "عرض جميع الشهادات",
    loading: "جاري التحميل...",
    noData: "غير متوفر",
    heresWhatsHappening: "إليك ما يحدث في موقعك اليوم.",
    customizeHomepage: "تخصيص صفحتك الرئيسية",
    createAndTrackCustomLinks: "إنشاء وتتبع الروابط المخصصة",
    generalSystemSettings: "إعدادات النظام العامة",
    quickActions: "الإجراءات السريعة",
    clickToViewDetails: "انقر لعرض التفاصيل",
  },

  // Homepage Settings
  homepageSettings: {
    title: "إعدادات الصفحة الرئيسية",
    subtitle: "تخصيص محتوى ومظهر صفحتك الرئيسية",
    previewHomepage: "معاينة الصفحة الرئيسية",
    saveChanges: "حفظ التغييرات",
    saving: "جاري الحفظ...",
    loadingSettings: "جاري تحميل الإعدادات...",
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToAccess:
      "يرجى تسجيل الدخول للوصول إلى إعدادات الصفحة الرئيسية.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    logIn: "تسجيل الدخول",
    pleaseLoginToSave: "يرجى تسجيل الدخول لحفظ الإعدادات.",
    sessionExpired: "انتهت صلاحية الجلسة",
    logoAndBranding: "الشعار والعلامة التجارية",
    uploadAndManageBrandAssets: "رفع وإدارة أصول علامتك التجارية",
    socialMedia: "وسائل التواصل الاجتماعي",
    manageYourSocialMediaLinks: "إدارة روابط وسائل التواصل الاجتماعي",
    contactInfo: "معلومات الاتصال",
    manageYourContactInformation: "إدارة معلومات الاتصال الخاصة بك",
    aboutUs: "من نحن",
    manageYourAboutUsContent: "إدارة محتوى من نحن",
    heroSlider: "شريط البطل",
    manageYourHeroSlider: "إدارة شرائح شريط البطل",
    headTags: "علامات الرأس",
    manageHeadTags: "إدارة علامات الميتا و Open Graph وعناصر الرأس الأخرى",
    addSlide: "إضافة شريحة",
    removeSlide: "إزالة شريحة",
    slideImage: "صورة الشريحة",
    slideTitle: "عنوان الشريحة",
    slideTitleArabic: "عنوان الشريحة (بالعربية)",
    slideDescription: "وصف الشريحة",
    slideDescriptionArabic: "وصف الشريحة (بالعربية)",
    buttonText: "نص الزر",
    buttonTextArabic: "نص الزر (بالعربية)",
    buttonLink: "رابط الزر",
    companyName: "اسم الشركة",
    companyNameArabic: "اسم الشركة (بالعربية)",
    tagline: "الشعار",
    taglineArabic: "الشعار (بالعربية)",
    heroBackground: "خلفية البطل",
    facebook: "فيسبوك",
    twitter: "تويتر",
    linkedin: "لينكد إن",
    instagram: "إنستغرام",
    youtube: "يوتيوب",
    tiktok: "تيك توك",
    snapchat: "سناب شات",
    pinterest: "بينتيريست",
    telegram: "تيليجرام",
    whatsapp: "واتساب",
    discord: "ديسكورد",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    addressArabic: "العنوان (بالعربية)",
    addressLink: "رابط العنوان",
    whatsappDefaultMessage: "رسالة واتساب الافتراضية",
    aboutContent: "محتوى من نحن",
    aboutContentArabic: "محتوى من نحن (بالعربية)",
    footerParagraph: "فقرة التذييل",
    footerParagraphArabic: "فقرة التذييل (بالعربية)",
    uploadImage: "رفع صورة",
    removeImage: "إزالة الصورة",
    enterCompanyName: "أدخل اسم الشركة",
    enterCompanyNameArabic: "أدخل اسم الشركة بالعربية",
    enterTagline: "أدخل شعار الشركة",
    enterTaglineArabic: "أدخل شعار الشركة بالعربية",
    enterPhoneNumber: "أدخل رقم الهاتف",
    enterEmailAddress: "أدخل عنوان البريد الإلكتروني",
    enterAddress: "أدخل العنوان",
    enterAddressArabic: "أدخل العنوان بالعربية",
    enterWhatsAppDefaultMessage: "أدخل الرسالة الافتراضية لواتساب",
    enterAboutContent: "أدخل محتوى من نحن",
    enterAboutContentArabic: "أدخل محتوى من نحن بالعربية",
    enterFooterParagraph: "أدخل فقرة التذييل",
    enterFooterParagraphArabic: "أدخل فقرة التذييل بالعربية",
    enterSocialMediaUrl: "أدخل رابط وسائل التواصل الاجتماعي",
    settingsSavedSuccessfully: "تم حفظ الإعدادات بنجاح!",
    errorSavingSettings: "خطأ في حفظ الإعدادات",
    placeholderEnterCompanyName: "أدخل اسم الشركة",
    placeholderEnterCompanyNameArabic: "أدخل اسم الشركة",
    placeholderEnterCompanyTagline: "أدخل شعار الشركة",
    placeholderEnterCompanyTaglineArabic: "أدخل شعار الشركة",
    placeholderEnterEmailAddress: "أدخل عنوان البريد الإلكتروني",
    placeholderEnterPhoneNumber: "أدخل رقم الهاتف",
    placeholderEnterFooterText:
      "أدخل نص التذييل (مثل إشعار حقوق النشر، وصف الشركة)",
    placeholderEnterFooterTextArabic:
      "أدخل نص التذييل (مثل إشعار حقوق النشر، وصف الشركة)",
    placeholderEnterFullAddress: "أدخل العنوان الكامل",
    placeholderEnterFullAddressArabic: "أدخل العنوان الكامل",
    placeholderEnterAboutUsTitle: "أدخل عنوان من نحن",
    placeholderEnterAboutUsTitleArabic: "أدخل عنوان من نحن",
    placeholderEnterAboutUsDescription: "أدخل وصف من نحن",
    placeholderEnterAboutUsDescriptionArabic: "أدخل وصف من نحن",
    addImage: "إضافة صورة",
  },

  // Special Offers Dashboard
  specialOffersDashboard: {
    loadingOffers: "جاري تحميل العروض الخاصة...",
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToManage: "يرجى تسجيل الدخول لإدارة العروض الخاصة.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    manageYourOffers: "إدارة العروض الخاصة والترويجات",
    addFirstOffer: "إضافة العرض الأول",
    addFirstOfferDescription: "أضف عرضك الخاص الأول للبدء",
    image: "الصورة",
    title: "العنوان",
    contentPreview: "معاينة المحتوى",
    status: "الحالة",
    created: "تاريخ الإنشاء",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    editOffer: "تعديل العرض",
    deleteOffer: "حذف العرض",
    deleteConfirmMessage: "هل أنت متأكد من أنك تريد حذف هذا العرض الخاص؟",
    offerDeletedSuccessfully: "تم حذف العرض الخاص بنجاح!",
    errorDeletingOffer: "خطأ في حذف العرض الخاص.",
    offerActivatedSuccessfully: "تم تفعيل العرض بنجاح!",
    offerDeactivatedSuccessfully: "تم إلغاء تفعيل العرض بنجاح!",
    errorUpdatingOffer: "خطأ في تحديث حالة العرض",
  },

  // Add/Edit Special Offer Pages
  addEditOffer: {
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToCreate: "يرجى تسجيل الدخول لإنشاء العروض الخاصة.",
    pleaseLoginToEdit: "يرجى تسجيل الدخول لتعديل العروض الخاصة.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    backToOffers: "العودة إلى العروض",
    addNewSpecialOffer: "إضافة عرض خاص جديد",
    editSpecialOffer: "تعديل العرض الخاص",
    createNewOffer: "إنشاء عرض خاص أو ترويج جديد",
    updateOfferDetails: "تحديث تفاصيل العرض الخاص",
    loadingOffer: "جاري تحميل العرض...",
    offerNotFound: "العرض غير موجود",
    offerNotFoundMessage: "العرض الخاص الذي تبحث عنه غير موجود.",
    offerTitleEnglish: "عنوان العرض (باللغة الإنجليزية)",
    offerTitleArabic: "عنوان العرض (باللغة العربية)",
    offerImage: "صورة العرض",
    offerContentEnglish: "محتوى العرض (باللغة الإنجليزية)",
    offerContentArabic: "محتوى العرض (باللغة العربية)",
    activeOffer: "عرض نشط",
    keywords: "الكلمات المفتاحية",
    enterKeywords: "أدخل الكلمات المفتاحية (مفصولة بفواصل)",
    keywordsHint: "افصل الكلمات المفتاحية بفواصل (مثال: خدمة، صيانة، إصلاح)",
    metaTitle: "عنوان SEO",
    enterMetaTitle: "أدخل عنوان SEO (اختياري)",
    metaTitleHint: "إذا تم توفيره، سيتم استخدامه كعنوان الصفحة بدلاً من عنوان العرض",
    metaDescription: "وصف SEO",
    enterMetaDescription: "أدخل وصف SEO (اختياري)",
    metaDescriptionHint: "إذا تم توفيره، سيتم استخدامه كوصف الصفحة بدلاً من الوصف العام",
    enterOfferTitle: "أدخل عنوان العرض",
    enterOfferTitleArabic: "أدخل عنوان العرض",
    enterOfferDetails: "أدخل تفاصيل العرض والشروط والأحكام...",
    enterOfferDetailsArabic: "أدخل تفاصيل العرض والشروط والأحكام...",
    cancel: "إلغاء",
    createOffer: "إنشاء العرض",
    updateOffer: "تحديث العرض",
    creating: "جاري الإنشاء...",
    updating: "جاري التحديث...",
    pleaseLoginToSave: "يرجى تسجيل الدخول لحفظ العروض الخاصة.",
    pleaseEnterTitle: "يرجى إدخال عنوان للعرض.",
    pleaseEnterContent: "يرجى إدخال محتوى للعرض.",
    offerCreatedSuccessfully: "تم إنشاء العرض الخاص بنجاح!",
    offerUpdatedSuccessfully: "تم تحديث العرض الخاص بنجاح!",
    errorCreatingOffer: "خطأ في إنشاء العرض الخاص.",
    errorUpdatingOffer: "خطأ في تحديث العرض الخاص.",
    ctaSection: "قسم الدعوة إلى العمل (CTA)",
    ctaTitle: "عنوان CTA",
    ctaTitleAr: "عنوان CTA (بالعربية)",
    ctaDescription: "وصف CTA",
    ctaDescriptionAr: "وصف CTA (بالعربية)",
    ctaButton1Text: "نص الزر الأول",
    ctaButton1TextAr: "نص الزر الأول (بالعربية)",
    ctaButton2Text: "نص الزر الثاني",
    ctaButton2TextAr: "نص الزر الثاني (بالعربية)",
    enterCtaTitle: "أدخل عنوان CTA",
    enterCtaTitleAr: "أدخل عنوان CTA",
    enterCtaDescription: "أدخل وصف CTA",
    enterCtaDescriptionAr: "أدخل وصف CTA",
    enterCtaButton1Text: "أدخل نص الزر الأول (مثل: اتصل بنا الآن)",
    enterCtaButton1TextAr: "أدخل نص الزر الأول",
    enterCtaButton2Text: "أدخل نص الزر الثاني (مثل: عرض جميع العروض)",
    enterCtaButton2TextAr: "أدخل نص الزر الثاني",
    ctaButton1Link: "رابط الزر الأول",
    ctaButton2Link: "رابط الزر الثاني",
    enterCtaButton1Link: "أدخل رابط الزر الأول (مثل: /#contact أو https://example.com)",
    enterCtaButton2Link: "أدخل رابط الزر الثاني (مثل: /offers أو https://example.com)",
    ctaButtonLinkHint: "أدخل مسار نسبي (مثل: /#contact) أو رابط كامل (مثل: https://example.com). اتركه فارغًا لاستخدام السلوك الافتراضي.",
  },

  // Services Dashboard
  servicesDashboard: {
    loading: "جاري التحميل...",
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToManage: "يرجى تسجيل الدخول لإدارة فئات الخدمات.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    servicesCategories: "فئات الخدمات",
    manageServiceCategories: "إدارة فئات الخدمات",
    addNewCategory: "إضافة فئة جديدة",
    title: "العنوان",
    status: "الحالة",
    created: "تاريخ الإنشاء",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    editCategory: "تعديل الفئة",
    deleteCategory: "حذف الفئة",
    deleteConfirmMessage: "هل أنت متأكد من أنك تريد حذف هذه الفئة؟",
    categoryDeletedSuccessfully: "تم حذف الفئة بنجاح!",
    errorDeletingCategory: "خطأ في حذف الفئة.",
    noCategoriesFound: "لم يتم العثور على فئات",
    backToCategories: "العودة إلى الفئات",
  },

  // Add/Edit Category Pages
  addEditCategory: {
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToCreate: "يرجى تسجيل الدخول لإنشاء فئات الخدمات.",
    pleaseLoginToEdit: "يرجى تسجيل الدخول لتعديل فئات الخدمات.",
    addNewCategory: "إضافة فئة جديدة",
    editCategory: "تعديل الفئة",
    createNewCategory: "إنشاء فئة خدمة جديدة",
    editExistingCategory: "تعديل فئة خدمة موجودة",
    categoryTitleEnglish: "عنوان الفئة (الإنجليزية) *",
    categoryTitleArabic: "عنوان الفئة (العربية)",
    enterCategoryTitle: "أدخل عنوان الفئة",
    enterCategoryTitleAr: "أدخل عنوان الفئة",
    categoryImage: "صورة الفئة",
    categoryDescriptionEnglish: "وصف الفئة (الإنجليزية)",
    categoryDescriptionArabic: "وصف الفئة (العربية)",
    enterCategoryDescription: "أدخل وصف الفئة...",
    enterCategoryDescriptionArabic: "أدخل وصف الفئة...",
    activeCategory: "فئة نشطة",
    pleaseEnterTitle: "يرجى إدخال عنوان للفئة.",
    categoryCreatedSuccessfully: "تم إنشاء الفئة بنجاح!",
    categoryUpdatedSuccessfully: "تم تحديث الفئة بنجاح!",
    errorCreatingCategory: "خطأ في إنشاء الفئة.",
    errorUpdatingCategory: "خطأ في تحديث الفئة.",
    pleaseLoginToSave: "يرجى تسجيل الدخول لحفظ الفئات.",
    cancel: "إلغاء",
    save: "حفظ",
    saving: "جاري الحفظ...",
    categoryNotFound: "الفئة غير موجودة",
    categoryNotFoundMessage: "الفئة التي تبحث عنها غير موجودة.",
  },

  // Add/Edit Service Pages
  addEditService: {
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToCreate: "يرجى تسجيل الدخول لإنشاء الخدمات.",
    pleaseLoginToEdit: "يرجى تسجيل الدخول لتعديل الخدمات.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    backToServices: "العودة إلى الخدمات",
    addNewService: "إضافة خدمة جديدة",
    editService: "تعديل الخدمة",
    createNewService: "إنشاء خدمة جديدة",
    updateServiceDetails: "تحديث تفاصيل الخدمة",
    loadingService: "جاري تحميل الخدمة...",
    serviceNotFound: "الخدمة غير موجودة",
    serviceNotFoundMessage: "الخدمة التي تبحث عنها غير موجودة.",
    serviceTitleEnglish: "عنوان الخدمة (باللغة الإنجليزية)",
    serviceTitleArabic: "عنوان الخدمة (باللغة العربية)",
    serviceImage: "صورة الخدمة",
    multipleImages: "صور إضافية",
    serviceContentEnglish: "محتوى الخدمة (باللغة الإنجليزية)",
    serviceContentArabic: "محتوى الخدمة (باللغة العربية)",
    serviceCategory: "فئة الخدمة",
    selectCategory: "اختر الفئة",
    activeService: "خدمة نشطة",
    keywords: "الكلمات المفتاحية",
    enterKeywords: "أدخل الكلمات المفتاحية (مفصولة بفواصل)",
    keywordsHint: "افصل الكلمات المفتاحية بفواصل (مثال: خدمة، صيانة، إصلاح)",
    metaTitle: "عنوان SEO",
    enterMetaTitle: "أدخل عنوان SEO (اختياري)",
    metaTitleHint: "إذا تم توفيره، سيتم استخدامه كعنوان الصفحة بدلاً من عنوان الخدمة",
    metaDescription: "وصف SEO",
    enterMetaDescription: "أدخل وصف SEO (اختياري)",
    metaDescriptionHint: "إذا تم توفيره، سيتم استخدامه كوصف الصفحة بدلاً من الوصف العام",
    enterServiceTitle: "أدخل عنوان الخدمة",
    enterServiceTitleArabic: "أدخل عنوان الخدمة",
    enterServiceDetails: "أدخل تفاصيل الخدمة والميزات والفوائد...",
    enterServiceDetailsArabic: "أدخل تفاصيل الخدمة والميزات والفوائد...",
    cancel: "إلغاء",
    createService: "إنشاء الخدمة",
    updateService: "تحديث الخدمة",
    creating: "جاري الإنشاء...",
    updating: "جاري التحديث...",
    pleaseLoginToSave: "يرجى تسجيل الدخول لحفظ الخدمات.",
    pleaseEnterTitle: "يرجى إدخال عنوان للخدمة.",
    pleaseEnterContent: "يرجى إدخال محتوى للخدمة.",
    pleaseSelectCategory: "يرجى اختيار فئة للخدمة.",
    serviceCreatedSuccessfully: "تم إنشاء الخدمة بنجاح!",
    serviceUpdatedSuccessfully: "تم تحديث الخدمة بنجاح!",
    errorCreatingService: "خطأ في إنشاء الخدمة.",
    errorUpdatingService: "خطأ في تحديث الخدمة.",
    ctaSection: "قسم الدعوة إلى العمل (CTA)",
    ctaTitle: "عنوان CTA",
    ctaTitleAr: "عنوان CTA (بالعربية)",
    ctaDescription: "وصف CTA",
    ctaDescriptionAr: "وصف CTA (بالعربية)",
    ctaButton1Text: "نص الزر الأول",
    ctaButton1TextAr: "نص الزر الأول (بالعربية)",
    ctaButton2Text: "نص الزر الثاني",
    ctaButton2TextAr: "نص الزر الثاني (بالعربية)",
    enterCtaTitle: "أدخل عنوان CTA",
    enterCtaTitleAr: "أدخل عنوان CTA",
    enterCtaDescription: "أدخل وصف CTA",
    enterCtaDescriptionAr: "أدخل وصف CTA",
    enterCtaButton1Text: "أدخل نص الزر الأول (مثل: اتصل بنا الآن)",
    enterCtaButton1TextAr: "أدخل نص الزر الأول",
    enterCtaButton2Text: "أدخل نص الزر الثاني (مثل: عرض جميع الخدمات)",
    enterCtaButton2TextAr: "أدخل نص الزر الثاني",
    ctaButton1Link: "رابط الزر الأول",
    ctaButton2Link: "رابط الزر الثاني",
    enterCtaButton1Link: "أدخل رابط الزر الأول (مثل: /#contact أو https://example.com)",
    enterCtaButton2Link: "أدخل رابط الزر الثاني (مثل: /offers أو https://example.com)",
    ctaButtonLinkHint: "أدخل مسار نسبي (مثل: /#contact) أو رابط كامل (مثل: https://example.com). اتركه فارغًا لاستخدام السلوك الافتراضي.",
  },

  // Services Main Dashboard
  servicesMainDashboard: {
    loading: "جاري التحميل...",
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToManage: "يرجى تسجيل الدخول لإدارة الخدمات.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    services: "الخدمات",
    manageYourServices: "إدارة خدماتك",
    addNewService: "إضافة خدمة جديدة",
    image: "الصورة",
    title: "العنوان",
    category: "الفئة",
    contentPreview: "معاينة المحتوى",
    status: "الحالة",
    created: "تاريخ الإنشاء",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    noCategory: "لا توجد فئة",
    editService: "تعديل الخدمة",
    deleteService: "حذف الخدمة",
    deleteConfirmMessage: "هل أنت متأكد من أنك تريد حذف هذه الخدمة؟",
    serviceDeletedSuccessfully: "تم حذف الخدمة بنجاح!",
    errorDeletingService: "خطأ في حذف الخدمة.",
    serviceActivatedSuccessfully: "تم تفعيل الخدمة بنجاح!",
    serviceDeactivatedSuccessfully: "تم إلغاء تفعيل الخدمة بنجاح!",
    errorUpdatingService: "خطأ في تحديث حالة الخدمة",
  },

  // Testimonials Dashboard
  testimonialsDashboard: {
    loading: "جاري التحميل...",
    authenticationRequired: "مطلوب تسجيل الدخول",
    pleaseLoginToManage: "يرجى تسجيل الدخول لإدارة الشهادات.",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    testimonials: "الشهادات",
    manageYourTestimonials: "إدارة شهاداتك",
    addNewTestimonial: "إضافة شهادة جديدة",
    image: "الصورة",
    name: "الاسم",
    rating: "التقييم",
    content: "المحتوى",
    status: "الحالة",
    created: "تاريخ الإنشاء",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    editTestimonial: "تعديل الشهادة",
    deleteTestimonial: "حذف الشهادة",
    deleteConfirmMessage: "هل أنت متأكد من أنك تريد حذف هذه الشهادة؟",
    testimonialDeletedSuccessfully: "تم حذف الشهادة بنجاح!",
    errorDeletingTestimonial: "خطأ في حذف الشهادة.",
    noTestimonialsYet: "لا توجد شهادات بعد",
    getStartedByCreating: "ابدأ بإنشاء شهادتك الأولى.",
    addFirstTestimonial: "إضافة الشهادة الأولى",
  },

  // Add/Edit Testimonial Pages
  addEditTestimonial: {
    backToTestimonials: "العودة إلى الشهادات",
    addNewTestimonial: "إضافة شهادة جديدة",
    editTestimonial: "تعديل الشهادة",
    createNewTestimonial: "إنشاء شهادة جديدة",
    updateTestimonialDetails: "تحديث تفاصيل الشهادة",
    loadingTestimonial: "جاري تحميل الشهادة...",
    testimonialNotFound: "الشهادة غير موجودة",
    testimonialNotFoundMessage: "الشهادة التي تبحث عنها غير موجودة.",
    customerNameEnglish: "اسم العميل (باللغة الإنجليزية)",
    customerNameArabic: "اسم العميل (باللغة العربية)",
    testimonialContentEnglish: "محتوى الشهادة (باللغة الإنجليزية)",
    testimonialContentArabic: "محتوى الشهادة (باللغة العربية)",
    rating: "التقييم",
    testimonialImage: "صورة الشهادة",
    enterCustomerName: "أدخل اسم العميل",
    enterCustomerNameArabic: "أدخل اسم العميل",
    enterTestimonialContent: "أدخل محتوى الشهادة...",
    enterTestimonialContentArabic: "أدخل محتوى الشهادة...",
    cancel: "إلغاء",
    createTestimonial: "إنشاء الشهادة",
    updateTestimonial: "تحديث الشهادة",
    creating: "جاري الإنشاء...",
    updating: "جاري التحديث...",
    pleaseEnterName: "يرجى إدخال اسم العميل.",
    pleaseEnterContent: "يرجى إدخال محتوى الشهادة.",
    testimonialCreatedSuccessfully: "تم إنشاء الشهادة بنجاح!",
    testimonialUpdatedSuccessfully: "تم تحديث الشهادة بنجاح!",
    errorCreatingTestimonial: "خطأ في إنشاء الشهادة.",
    errorUpdatingTestimonial: "خطأ في تحديث الشهادة.",
  },

  // Links Dashboard
  linksDashboard: {
    loading: "جاري تحميل الروابط...",
    linkManagement: "إدارة الروابط",
    createAndTrackLinks: "إنشاء وتتبع روابط مخصصة لخدماتك وعروضك",
    createNewLink: "إنشاء رابط جديد",
    title: "العنوان",
    description: "الوصف",
    type: "النوع",
    target: "الهدف",
    customUrl: "رابط مخصص",
    shortUrl: "رابط مختصر",
    clicks: "النقرات",
    status: "الحالة",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    service: "خدمة",
    offer: "عرض",
    custom: "مخصص",
    editLink: "تعديل الرابط",
    deleteLink: "حذف الرابط",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط إلى الحافظة!",
    deleteConfirmMessage: "هل أنت متأكد من أنك تريد حذف هذا الرابط؟",
    linkDeletedSuccessfully: "تم حذف الرابط بنجاح!",
    errorDeletingLink: "خطأ في حذف الرابط.",
    linkCreatedSuccessfully: "تم إنشاء الرابط بنجاح!",
    linkUpdatedSuccessfully: "تم تحديث الرابط بنجاح!",
    errorCreatingLink: "خطأ في إنشاء الرابط.",
    errorUpdatingLink: "خطأ في تحديث الرابط.",
    enterLinkTitle: "أدخل عنوان الرابط",
    enterLinkDescription: "أدخل وصف الرابط",
    enterCustomUrl: "أدخل رابط مخصص",
    pleaseEnterTitle: "يرجى إدخال عنوان.",
    pleaseSelectType: "يرجى اختيار نوع.",
    pleaseSelectTarget: "يرجى اختيار هدف.",
    noLinksYet: "لا توجد روابط بعد",
    getStartedByCreating: "ابدأ بإنشاء رابطك الأول.",
    addFirstLink: "إضافة الرابط الأول",
    totalLinks: "إجمالي الروابط",
    activeLinks: "الروابط النشطة",
    totalClicks: "إجمالي النقرات",
    created: "تاريخ الإنشاء",
    viewQRCode: "عرض رمز QR",
    createNewLink: "إنشاء رابط جديد",
    title: "العنوان",
    description: "الوصف",
    linkType: "نوع الرابط",
    service: "الخدمة",
    active: "نشط",
    selectService: "اختر خدمة",
    selectOffer: "اختر عرض",
    createLink: "إنشاء رابط",
    cancel: "إلغاء",
    enterLinkTitle: "أدخل عنوان الرابط",
    enterLinkDescription: "أدخل وصف الرابط",
  },

  // Analytics Dashboard
  analyticsDashboard: {
    loading: "جاري تحميل بيانات التحليلات...",
    backToDashboard: "العودة إلى لوحة التحكم",
    analyticsDashboard: "لوحة تحليلات الزوار",
    detailedVisitorAnalytics: "تحليلات وتفاصيل الزوار المفصلة",
    refresh: "تحديث",
    refreshing: "جاري التحديث...",
    period: "الفترة",
    today: "اليوم",
    thisWeek: "هذا الأسبوع",
    thisMonth: "هذا الشهر",
    thisYear: "هذا العام",
    custom: "مخصص",
    from: "من",
    to: "إلى",
    apply: "تطبيق",
    overview: "نظرة عامة",
    totalVisitors: "إجمالي الزوار",
    uniqueVisitors: "زوار فريدون",
    uniquePages: "صفحات فريدة",
    totalPageViews: "إجمالي مشاهدات الصفحات",
    averageSessionDuration: "متوسط مدة الجلسة",
    bounceRate: "معدل الارتداد",
    mostVisitedPages: "الصفحات الأكثر زيارة",
    page: "الصفحة",
    visits: "الزيارات",
    percentage: "النسبة المئوية",
    noDataFound: "لا توجد بيانات",
    serviceVisits: "زيارات الخدمات",
    noServiceVisitsFound: "لا توجد زيارات للخدمات",
    offerVisits: "زيارات العروض",
    noOfferVisitsFound: "لا توجد زيارات للعروض",
    visitors: "زوار",
    minutes: "دقائق",
    percent: "%",
    type: "النوع",
    service: "الخدمة",
    offer: "العرض",
  },

  // Visitor Details
  visitorDetails: {
    loading: "جاري تحميل بيانات الزوار...",
    error: "خطأ في تحميل البيانات",
    retry: "إعادة المحاولة",
    backToDashboard: "العودة إلى لوحة التحكم",
    visitorDetails: "تفاصيل الزوار",
    visitorAnalytics: "تحليلات وتفاصيل الزوار",
    refresh: "تحديث",
    period: "الفترة",
    today: "اليوم",
    thisWeek: "هذا الأسبوع",
    thisMonth: "هذا الشهر",
    allTime: "جميع الأوقات",
    totalVisitors: "إجمالي الزوار",
    visitTime: "وقت الزيارة",
    page: "الصفحة",
    pageType: "نوع الصفحة",
    ipAddress: "عنوان IP",
    country: "البلد",
    browser: "المتصفح",
    device: "الجهاز",
    referrer: "المصدر",
    direct: "مباشر",
    noVisitorsFound: "لم يتم العثور على زوار",
    previous: "السابق",
    next: "التالي",
    page: "صفحة",
    of: "من",
    localhost: "الخادم المحلي",
    unknownLocation: "موقع غير معروف",
    unknown: "غير معروف",
    local: "محلي",
    unknownCountry: "بلد غير معروف",
    mobile: "جوال",
    tablet: "تابلت",
    desktop: "سطح المكتب",
    other: "أخرى",
  },
};
